import { getCatalogSatAll } from '@machete/common-catalogs';

import api from '../../../lib/api';

export default {
  addTemporalNotification: {
    root: true,
    handler({ commit }, payload) {
      const { duration = 5000, ...notificationData } = payload;
      const now = new Date();

      notificationData.dateTime = now;

      commit('addNotification', notificationData);

      setTimeout(() => {
        commit('deleteNotification', now);
      }, duration);
    },
  },

  async deleteSku(store, product) {
    const {
      rootState,
    } = store;

    const {
      id,
    } = product;

    const { companyId: company } = rootState.auth;
    const { payload: response } = await api.catalogs.delSku(
      company,
      id,
    );

    return response;
  },

  async saveSku(store, sku) {
    const {
      rootState,
    } = store;

    const { companyId: company } = rootState.auth;

    return api.catalogs.putSku(
      company,
      sku,
    );
  },

  async getCatalog({ commit }, { catalogName, search }) {
    const { catalog } = await api.catalogs.getCatalog(catalogName, search);
    commit('pushEntriesCatalog', {
      catalog: catalogName,
      entries: catalog.map(({ value, label }) => ({ value, label: `${value} - ${label}` })),
    });

    return catalog;
  },

  async getCatalogSku({ commit }, { catalogName, search, query }) {
    const catalog = await api.catalogs.getCatalog(catalogName, search, query);
    commit('pushEntriesCatalog', {
      catalog: 'sku',
      entries: catalog.catalog.map(({
        id,
        sku,
        description,
        productServiceKey,
        unitKey,
        unitValue,
      }, index) => ({
        id,
        value: sku,
        description,
        productServiceKey,
        unitKey,
        unitValue,
        label: `${sku}`,
        rowId: index,
      })),
    });
    commit('setValue', { accessor: 'catalogs.totalPages', value: catalog.totalPages });
    commit('setValue', { accessor: 'catalogs.count', value: catalog.count });
    commit('setValue', { accessor: 'catalogs.page', value: catalog.page });

    return catalog;
  },

  async requestCatalogSat({ state, commit }, catalogName) {
    const currentEntries = state.catalogSat[catalogName];

    if (typeof currentEntries === 'undefined') {
      return [];
    }

    const accessor = `catalogSat.${catalogName}`;

    if (currentEntries.length > 0) {
      return currentEntries;
    }

    const entries = await getCatalogSatAll(catalogName);

    commit('setValue', { accessor, value: entries });

    return entries;
  },
};
